@if (disableControls) {
  <div [pTooltip]="tooltipContent" class="text-color-secondary" showDelay="300">
    @if (sliderOptions.maxValue) {
      {{ sliderOptions.minValue }} - {{ sliderOptions.maxValue }}
    } @else {
      {{ sliderOptions.minValue }}
    }
  </div>

  <ng-template #tooltipContent>
    <div class="flex align-items-baseline gap-2">
      <i class="fas fa-info-circle"></i> Jahresnavigation für diese Ansicht
      deaktiviert
    </div>
  </ng-template>
} @else {
  <div [style]="{ width: '40rem' }" class="flex gap-4 align-items-center">
    @if (allowOneYearFocusDropdown) {
      <p-dropdown
        placeholder="Jahr fixieren"
        variant="filled"
        [options]="availableYears"
        (onChange)="focusOnYear($event)"></p-dropdown>
    }
    @if (availableYears.length > 1) {
      @if (sliderOptions && sliderOptions.options) {
        @if (sliderOptions.maxValue) {
          <ngx-slider
            [value]="sliderOptions.minValue"
            [highValue]="sliderOptions.maxValue"
            [options]="sliderOptions.options"
            (userChangeEnd)="setNewYears($event)"></ngx-slider>
        } @else {
          <ngx-slider
            [value]="sliderOptions.minValue"
            [options]="sliderOptions.options"
            (userChangeEnd)="setNewYears($event)"></ngx-slider>
        }
      }
    } @else if (sliderOptions) {
      <div class="ml-auto text-color-secondary">
        {{ sliderOptions.minValue }}
      </div>
    }
  </div>
}
